/* eslint-disable default-param-last */
/**
 * @description Reducer sobre as manipulações de cargos
 * @author Bene Lemuel Dantas Gondim
 * @file cargosReducer.js
 *
 * @license Copyright (c) 2020 SIGEP DIGETI ITEP/RN
 */

import types from 'utils/actionTypes'

// Estado inicial da sessão no redux
const initialState = {
  cargos: [],
  processandoCargos: false,
  error: null,
  nomeFuncao: '',
  dados: {
    id: '',
    nome: '',
    sigla: '',
    descricao: '',
    permissoes: '',
  },
}

const cargosReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_CARGOS: {
      return {
        ...state,
        cargos: action.cargos,
      }
    }

    default: {
      return state
    }
  }
}

export default cargosReducer
